module.exports = __webpack_public_path__ + "static/media/日历2@2x.eb32f9e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_145/img/日历2@2x.png
// module id = 1375
// module chunks = 0